/**
 * @ Summary: This component is utilized to handle Level 4 click made in the WorkOrder Reports.
 */

import * as React from "react";
import { useEffect, useState } from "react";
import AssetRepository from "../../api/repositories/assetRepository";
import { useDispatch } from 'react-redux';
import { setFinalWorkOrderJSON } from '../../redux/actions/assetActions';
import { CircularProgress, Box } from "@mui/material";
import moment from 'moment';


//Map and display all WorkOrder related data for final level.
const WorkorderFinalreport = React.memo(({ finalReportDetails, workOrderType, serviceType, facilityId, facilityname }) => {
  const [vendorName, setVendorName] = useState('');
  const [partReplacementData, setpartReplacementData] = useState([]);
  const [dropdownDetails, setDropdownDetails] = useState([]);
  const [taskDetails, setTaskDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const companyId = localStorage.getItem("companyId");
  let newWoType;
  useEffect(() => {
    partReplacement();
    getTaskCodeDetails(finalReportDetails?.[0].wgId);
    if (finalWorkOrderJSON?.assessment?.respondType === "Inhouse") {
      getCommonDropdownValues();
    } else if (finalWorkOrderJSON?.assessment?.respondType === "Outsource") {
      getCommonDropdown();
    }
    maptoVendorDetails();
  }, []);

  const maptoVendorDetails = async (id) => {
    const vendorResponse = await AssetRepository.getVendorDetails();

    const vendor = vendorResponse?.find(v => v?.id === id);
    setVendorName(vendor ? vendor?.vendorname : '');


  };

  useEffect(() => {
    if (finalReportDetails?.length > 0) {
      setLoading(false);
    }
    maptoVendorDetails(finalWorkOrderJSON?.assessment?.vendorId || "")
  }, [finalReportDetails, dropdownDetails]);


  let getsubDetails = (finalReportDetails && finalReportDetails?.length > 0) ? finalReportDetails?.[0] : [];

  let category = "";

  const dispatch = useDispatch();
  if (getsubDetails) {
    if (finalReportDetails?.[0]?.workordercategory === "Unscheduled") {
      category = "UnScheduled";
    } else {
      category = "Scheduled";
    }
  }



  const partReplacement = async () => {
    try {
      const response = await AssetRepository.partReplacement(facilityId);
      if (getsubDetails) {
        const updatedPartReplacementData = [getsubDetails].flatMap((item) => {
          let partReplacementData = [];

          // Determine partReplacementData based on workOrderType and serviceType
          if (category === "Unscheduled" || workOrderType === 1) {
            if (serviceType === "FEMS") {
              partReplacementData = item?.femunscheduledworkorderheaders[0]?.femunscheduledwopartsreplacedetails || [];
            } else {
              if (serviceType === "BEMS") {
                partReplacementData = item?.bemunscheduledworkorderheaders[0]?.bemunscheduledwopartsreplacedetails || [];
              }
            }
          } else if (category === "scheduled" || workOrderType === 2) {
            if (serviceType === "FEMS") {
              partReplacementData = item?.femscheduledworkorderheaders[0]?.femscheduledwopartsreplacedetails || [];
            } else {
              if (serviceType === "BEMS") {
                partReplacementData = item?.bemscheduledworkorderheaders[0]?.bemscheduledwopartsreplacedetails || [];
              }
            }
          }
          return partReplacementData?.map((part) => {
            const matchingEntry = response?.find((resItem) => resItem?.id === part?.itemcodeid);
            return matchingEntry
              ? {
                partCode: matchingEntry?.itemcode,
                itemdesc: matchingEntry?.descriptionname,
                quantityUsed: part?.quantityused,
              }
              : {};
          });
        });
        setpartReplacementData(updatedPartReplacementData);
      }
    } catch (error) {
      console.error("Failed to fetch part replacement data:", error);
    }
  };

  const getTaskCodeDetails = async (workgroupdetailsId) => {
    try {
      const response = await AssetRepository.getTaskcdeDetails(workgroupdetailsId);

      const updatedtaskDetailsdata = (Array.isArray(getsubDetails) ? getsubDetails : [getsubDetails]).map((item) => {
        let taskDetailID;
        if (category === "Unscheduled" || workOrderType === 1) {
          if (serviceType === "FEMS") {
            taskDetailID = item?.taskcode;
          }
          else if (serviceType === "BEMS") {

            taskDetailID = item?.taskcode;

          }
        }
        else {
          if (category === "scheduled" || workOrderType === 2) {
            if (serviceType === "FEMS") {
              taskDetailID = item?.taskcode;
            }
            else if (serviceType === "BEMS") {
              taskDetailID = item?.taskcode;
            }
          }
        }
        const getTaskDetails = response?.find((res) => res?.taskcode === taskDetailID);
        return getTaskDetails ? getTaskDetails : [];
      });
      setTaskDetails(updatedtaskDetailsdata ? updatedtaskDetailsdata : []);
    } catch (error) {
      console.error("Failed to fetch part replacement data:", error);
    }
  };

  const getCommonDropdownValues = async () => {
    try {
      const response = await AssetRepository.filterDetails();
      const employeeResponse = await AssetRepository.getEmployeeDetails(facilityId);
      const updatedFlagdata = [getsubDetails].map((item) => {
        let filterDetails = [];
        if (category === "Unscheduled" || workOrderType === 1) {
          if (serviceType === "FEMS") {
            filterDetails = item?.femunscheduledworkorderheaders[0]?.femunscheduledwoassessmentheaders[0]?.femunscheduledworepairdetails || "";
          }
          else if (serviceType === "BEMS") {
            filterDetails = item?.bemunscheduledworkorderheaders[0]?.bemunscheduledwoassessmentheaders[0]?.bemunscheduledworepairdetails || "";
          }
        }
        else {
          if (category === "scheduled" || workOrderType === 2) {
            if (serviceType === "FEMS") {
              filterDetails = item?.femscheduledworkorderheaders[0]?.femscheduledwoassessmentheaders[0]?.femscheduledworepairdetails || "";
            }
            else if (serviceType === "BEMS") {
              filterDetails = item?.bemscheduledworkorderheaders[0]?.bemscheduledwoassessmentheaders[0]?.bemscheduledworepairdetails || "";
            }
          }
        }
        const filteredDetails = filterDetails?.filter((filter) =>
          employeeResponse?.some((empItem) => empItem?.id === filter?.employeeid)
        );


        return filteredDetails?.map((filter) => {
          const matchedFlagData = response?.femuschworepairflags.find(
            (res) =>
              [filter?.femuschworepairflagId, filter?.bemuschworepairflagId, filter?.femschworepairflagId, filter?.bemschworepairflagId].includes(res?.id)
          );
          const matchedPICData = response?.femuschworepairpics.find(
            (res) =>
              res?.id === filter?.femuschworepairpicId ||
              res?.id === filter?.bemuschworepairpicId ||
              res?.id === filter?.femschworepairpicId ||
              res?.id === filter?.bemschworepairpicId
          );
          const matchedActivityData = response?.femuschworepairactivities.find(
            (res) =>
              res?.id === filter?.femuschworepairactivityId ||
              res?.id === filter?.bemuschworepairactivityId ||
              res?.id === filter?.femschworepairactivityId ||
              res?.id === filter?.bemschworepairactivityId
          );
          const employeeData = employeeResponse?.find((empItem) => empItem?.id === filter?.employeeid);

          return {
            employeeName: employeeData?.employeename || "",
            employeeCode: employeeData?.employeecode || "",
            flagname: matchedFlagData?.repairflag || "",
            pic: matchedPICData?.repairpic || "",
            activity: matchedActivityData?.repairactivity || "",
            startDate: filter?.repairstartdate || "",
            endDate: filter?.repairenddate || "",
            repairDuration: filter?.repairduration || "",
            remarks: filter?.remarks || "",
          };

        });

      });

      // setDropdownDetails(updatedFlagdata[0]||"");
      setDropdownDetails(updatedFlagdata?.[0] || []);

    } catch (error) {
      console.error("Failed to fetch part replacement data: ", error);
    }
  };
  const getCommonDropdown = async () => {
    try {
      const response = await AssetRepository.filterDetails();

      const updatedFlagdata = (Array.isArray(getsubDetails) ? getsubDetails : [getsubDetails]).map((item) => {
        let filterDetails = [];
        if (category === "Unscheduled" || workOrderType === 1) {
          if (serviceType === "FEMS") {
            filterDetails = item?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.femunscheduledworepairdetails || "";
          }
          else if (serviceType === "BEMS") {
            filterDetails = item?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders[0]?.bemunscheduledworepairdetails || "";
          }
        }
        else {
          if (category === "scheduled" || workOrderType === 2) {
            if (serviceType === "FEMS") {
              filterDetails = item?.femscheduledworkorderheaders?.[0]?.femscheduledwoassessmentheaders?.[0]?.femscheduledworepairdetails || "";
            }
            else if (serviceType === "BEMS") {
              filterDetails = item?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.bemscheduledworepairdetails || "";
            }
          }
        }


        return filterDetails?.map((filter) => {
          const matchedFlagData = response?.femuschworepairflags.find(
            (res) =>
              [filter?.femuschworepairflagId, filter?.bemuschworepairflagId, filter?.femschworepairflagId, filter?.bemschworepairflagId].includes(res?.id)
          );

          const matchedPICData = response?.femuschworepairpics.find(
            (res) => res?.id === (filter?.femuschworepairpicId) || (filter?.bemuschworepairpicId) || (filter?.femschworepairpicId) || (filter?.bemschworepairpicId)

          );

          const matchedActivityData = response?.femuschworepairactivities.find(
            (res) => res?.id === (filter?.femuschworepairactivityId) || (filter?.bemuschworepairactivityId) || (filter?.femschworepairactivityId) || (filter?.bemschworepairactivityId)
          );
          return {


            vendortechnician: filter?.vendortechnician || "",
            flagname: matchedFlagData?.repairflag || "",
            pic: matchedPICData?.repairpic || "",
            activity: matchedActivityData?.repairactivity || "",
            startDate: filter?.repairstartdate || "",
            endDate: filter?.repairenddate || "",
            repairDuration: filter?.repairduration || "",
            remarks: filter?.remarks || "",

          };

        });

      });

      setDropdownDetails(updatedFlagdata?.[0]||[]);

    } catch (error) {
      console.error("Failed to fetch part replacement data: ", error);
    }
  };

  //Map and all WorkOrder related data for final level
  let finalWorkOrderJSON = {};

  try {
    if (category === "Unscheduled" || workOrderType === 1) {
      if (serviceType.trim().toUpperCase() === "FEMS") {


        finalWorkOrderJSON = {

          workOrderReport: {

            computerWorkOrderNo: getsubDetails?.workorderno || "",
            deptworkrequestno: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femdepartmentworkrequestheader?.deptworkrequestno || "",
            workOrderDate: getsubDetails?.workorderdate || "",
            assetNo: getsubDetails?.assetNo || "",
            description: getsubDetails?.assetDescription || "",
            location: getsubDetails?.locationdesc || "",
            workGroup: getsubDetails?.workGroup || "",
            workGroupdescription: getsubDetails?.wgdesc || "",
          },
          workOrderReceiptandClassification: {
            category: getsubDetails?.workordercategory || "",
            type: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femworkordertype.workordertype || "",
            priority:
              getsubDetails?.femunscheduledworkorderheaders?.[0]?.femworkorderpriority?.workorderpriority || "",
          },

          assessment: {
            respondedBy: getsubDetails?.assessmentEmployeename || "",
            respondStartDateandTime: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.responsestartdate || "",
            respondFinding: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.respondfinding || "",
            respondType: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.femworespondtype?.respondtype || "",
            designation: getsubDetails?.assessmentDesignation || "",
            respondEndDateTime: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders[0]?.responseenddate || "",
            taskCode: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.femtaskdetails.taskcode || "",
            vendorId: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwoassessmentheaders?.[0]?.vendorid || "",
          },

          repairDetails: {
            employeeDetails: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.employeeName || "") : [],
            flag: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.flagname || "") : [],
            pic: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.pic || "") : [],
            activity: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.activity || "") : [],
            strtDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.startDate || "") : [],
            endDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.endDate || "") : [],
            repairDuration: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.repairDuration || "") : [],
            remarks: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.remarks || "") : [],

          },

          repairDetailsForOutSource: {
            Vendor: vendorName || '',
            VendorTechnical: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.vendortechnician || "") : [],
            flag: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.flagname || "") : [],
            pic: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.pic || "") : [],
            activity: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.activity || "") : [],
            strtDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.startDate || "") : [],
            endDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.endDate || "") : [],
            repairDuration: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.repairDuration || "") : [],
            remarks: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.remarks || "") : [],
          },
          partReplacement: {
            itemOrPartCode: partReplacementData?.map(part => part?.partCode) || " ",
            itemdescription: partReplacementData?.map(part => part?.itemdesc) || "",
            quantityUsed: partReplacementData?.map(part => part?.quantityUsed) || "",
          },
          unScheduleWorkCarriedOutBy: {
            employeeName: dropdownDetails?.map(filter => filter?.employeeName) || "",
            employeeId: dropdownDetails?.map(filter => filter?.employeeCode) || "",
            startDateTime: dropdownDetails?.map(filter => filter?.startDate) || "",
            endDateTime: dropdownDetails?.map(filter => filter?.endDate) || "",
            repairHours: dropdownDetails?.map(filter => filter?.repairDuration) || "",
          },
          sparePartsUsed: {
            partNo: taskDetails[0]?.taskcode || " ",
            PartDescription: taskDetails[0]?.taskdesc || " ",
            ItemNo: partReplacementData[0]?.itemdesc || " ",
            quantity: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwopartsreplacedetails?.[0]?.quantityused || "",
            cost: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwopartsreplacedetails?.[0]?.partscost || "",
          },
          costDetails: {
            breakDownCost: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails[0]?.breakdowncost || "",
            poNumber: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || "",
            ppmCost: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.ppmcost || "",
            ppmPONumber: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || "",
            ppmCostByContract: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.contractppmcost || "",
            contractReferenceNumber: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.contractrefno || "",
            sparPartCost: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.sparepartscost || "",
            totalWoCost: getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.totalwocost || "",
          },
          completionDetails: {
            rootCause:
              getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.rootcause || "",
            startDateTime:
              getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.startdate || "",
            AcceptedBy: getsubDetails?.completionEmployeename || getsubDetails?.completionByEmployeename || "",
            Designation: getsubDetails?.completionDesignation || getsubDetails?.completionByDesignation || "",
            ActionTaken:
              getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.actiontaken || "",
            endDateTime:
              getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.enddate || "",
            assetRequiredbutnotAvailable:
              getsubDetails?.femunscheduledworkorderheaders?.[0]?.femunscheduledwocompletiondetails?.[0]?.isassetreqnotavail || "",
          },
        };

      }

      else if (serviceType === "BEMS") {
        finalWorkOrderJSON = {
          workOrderReport: {
            computerWorkOrderNo: getsubDetails?.workorderno || "",
            deptworkrequestno: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemdepartmentworkrequestheader?.deptworkrequestno || "",
            workOrderDate: getsubDetails?.workorderdate || "",
            assetNo: getsubDetails?.assetNo || "",
            description: getsubDetails?.assetDescription || "",
            location: getsubDetails?.locationdesc || "",
            workGroup: getsubDetails?.workGroup || "",
            workGroupdescription: getsubDetails?.wgdesc || "",
          },
          workOrderReceiptandClassification: {
            category: getsubDetails?.workordercategory || "",
            type: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemworkordertype?.workordertype || "",
            priority:
              getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemworkorderpriority?.workorderpriority || "",
          },
          assessment: {
            respondedBy: getsubDetails?.assessmentEmployeename || "",
            respondStartDateandTime: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.responsestartdate || "",
            respondFinding: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.respondfinding || "",
            respondType: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.bemworespondtype?.respondtype || "",
            designation: getsubDetails?.assessmentDesignation || "",
            respondEndDateTime: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.responseenddate || "",
            taskCode: getsubDetails?.taskcode || "",
            vendorId: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwoassessmentheaders?.[0]?.vendorid || "",
          },
          repairDetails: {
            employeeDetails: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.employeeName || "") : '',
            flag: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.flagname || "") : '',
            pic: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.pic || "") : '',
            activity: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.activity || "") : '',
            strtDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.startDate || "") : '',
            endDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.endDate || "") : '',
            repairDuration: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.repairDuration || "") : '',
            remarks: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.remarks || "") : '',
          },
          repairDetailsForOutSource: {
            Vendor: vendorName || '',
            VendorTechnical: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.vendortechnician || "") : '',
            flag: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.flagname || "") : '',
            pic: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.pic || "") : '',
            activity: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.activity || "") : '',
            strtDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.startDate || "") : '',
            endDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.endDate || "") : '',
            repairDuration: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.repairDuration || "") : '',
            remarks: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.remarks || "") : '',

          },
          partReplacement: {
            itemOrPartCode: partReplacementData?.map(part => part?.partCode) || " ",
            itemdescription: partReplacementData?.map(part => part?.itemdesc) || "",
            quantityUsed: partReplacementData?.map(part => part?.quantityUsed) || "",
          },
          unScheduleWorkCarriedOutBy: {
            employeeName: dropdownDetails?.map(filter => filter?.employeeName) || "",
            employeeId: dropdownDetails?.map(filter => filter?.employeeCode) || "",
            startDateTime: dropdownDetails?.map(filter => filter?.startDate) || "",
            endDateTime: dropdownDetails?.map(filter => filter?.endDate) || "",
            repairHours: dropdownDetails?.map(filter => filter?.repairDuration) || "",
          },
          sparePartsUsed: {
            partNo: taskDetails[0]?.taskcode || " ",
            PartDescription: taskDetails[0]?.taskdesc || " ",
            ItemNo: partReplacementData[0]?.itemdesc || " ",
            quantity: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwopartsreplacedetails?.[0]?.quantityused || "",
            cost: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwopartsreplacedetails?.[0]?.partscost || "",
          },
          costDetails: {
            breakDownCost: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || "",
            poNumber: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || "",
            ppmCost: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.ppmcost || "",
            ppmPONumber: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || "",
            ppmCostByContract: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.contractppmcost || "",
            contractReferenceNumber: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.contractrefno || "",
            sparPartCost: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.sparepartscost || "",
            totalWoCost: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.totalwocost || "",
          },
          completionDetails: {
            rootCause: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.rootcause || "",
            startDateTime: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.startdate || "",
            AcceptedBy: getsubDetails?.completionEmployeename || getsubDetails?.completionByEmployeename || "",
            Designation: getsubDetails?.completionDesignation || getsubDetails?.completionByDesignation || "",
            ActionTaken: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.actiontaken || "",
            endDateTime: getsubDetails?.bemunscheduledworkorderheaders[0]?.bemunscheduledwocompletiondetails[0]?.enddate || "",
            assetRequiredbutnotAvailable: getsubDetails?.bemunscheduledworkorderheaders?.[0]?.bemunscheduledwocompletiondetails?.[0]?.isassetreqnotavail || "",
          }
        };
      }
    } else {
      if (category === "scheduled" || workOrderType === 2) {
        if (serviceType === "FEMS") {
          finalWorkOrderJSON = {
            workOrderReport: {
              computerWorkOrderNo: getsubDetails?.workorderno || "",
              deptworkrequestno: getsubDetails?.femscheduledworkorderheaders?.[0]?.femdepartmentworkrequestheader?.deptworkrequestno || "",
              workOrderDate: getsubDetails?.workorderdate || "",
              assetNo: getsubDetails?.assetNo || "",
              description: getsubDetails?.assetDescription || "",
              location: getsubDetails?.locationdesc || "",
              workGroup: getsubDetails?.workGroup || "",
              workGroupdescription: getsubDetails?.wgdesc || "",
            },
            workOrderReceiptandClassification: {
              category: getsubDetails?.workordercategory || "",
              type: getsubDetails?.femscheduledworkorderheaders?.[0]?.femworkordertype?.workordertype || "",
              priority:
                getsubDetails?.femscheduledworkorderheaders?.[0]?.femworkorderpriority?.workorderpriority || "",
            },
            assessment: {
              respondedBy: getsubDetails?.assessmentEmployeename || "",
              respondStartDateandTime: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwoassessmentheaders?.[0]?.responsestartdate || "",
              respondFinding:
                getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwoassessmentheaders?.[0]?.respondfinding || "",
              respondType: getsubDetails?.femworespondtype || "",
              designation: getsubDetails?.assessmentDesignation || "",
              respondEndDateTime:
                getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwoassessmentheaders?.[0]?.responseenddate || "",
              taskCode: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwoassessmentheaders?.[0]?.femtaskdetails?.taskcode || "",
              vendorId: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwoassessmentheaders?.[0]?.vendorid || "",

            },
            repairDetails: {
              employeeDetails: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.employeeName || "") : '',
              flag: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.flagname || "") : '',
              pic: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.pic || "") : '',
              activity: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.activity || "") : '',
              strtDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.startDate || "") : '',
              endDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.endDate || "") : '',
              repairDuration: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.repairDuration || "") : '',
              remarks: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.remarks || "") : '',

            },
            repairDetailsForOutSource: {
              Vendor: vendorName || '',
              VendorTechnical: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.vendortechnician || "") : '',
              flag: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.flagname || "") : '',
              pic: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.pic || "") : '',
              activity: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.activity || "") : '',
              strtDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.startDate || "") : '',
              endDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.endDate || "") : '',
              repairDuration: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.repairDuration || "") : '',
              remarks: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.remarks || "") : '',

            },
            partReplacement: {
              itemOrPartCode: partReplacementData?.map(part => part?.partCode) || " ",
              itemdescription: partReplacementData?.map(part => part?.itemdesc) || "",
              quantityUsed: partReplacementData?.map(part => part?.quantityUsed) || "",
            },
            unScheduleWorkCarriedOutBy: {
              employeeName: dropdownDetails?.map(filter => filter?.employeeName) || "",
              employeeId: dropdownDetails?.map(filter => filter?.employeeCode) || "",
              startDateTime: dropdownDetails?.map(filter => filter?.startDate) || "",
              endDateTime: dropdownDetails?.map(filter => filter?.endDate) || "",
              repairHours: dropdownDetails?.map(filter => filter?.repairDuration) || "",
            },
            sparePartsUsed: {
              partNo: taskDetails[0]?.taskcode || " ",
              PartDescription: taskDetails[0]?.taskdesc || " ",
              ItemNo: partReplacementData[0]?.itemdesc || " ",
              quantity: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwopartsreplacedetails?.[0]?.quantityused || "",
              cost: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwopartsreplacedetails?.[0]?.partscost || "",
            },
            costDetails: {
              breakDownCost: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || "",
              poNumber: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || "",
              ppmCost: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.ppmcost || "",
              ppmPONumber: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || "",
              ppmCostByContract: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.contractppmcost || "",
              contractReferenceNumber: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.contractrefno || "",
              sparPartCost: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.sparepartscost || "",
              totalWoCost: getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.totalwocost || "",
            },
            completionDetails: {
              rootCause:
                getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.rootcause || "",
              startDateTime:
                getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.startdate || "",
              AcceptedBy: getsubDetails?.completionEmployeename || getsubDetails?.completionByEmployeename || "",
              Designation: getsubDetails?.completionDesignation || getsubDetails?.completionByDesignation || "",
              ActionTaken:
                getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.actiontaken || "",
              endDateTime:
                getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.enddate || "",
              assetRequiredbutnotAvailable:
                getsubDetails?.femscheduledworkorderheaders?.[0]?.femscheduledwocompletiondetails?.[0]?.isassetreqnotavail || "",
            }
          };
        }
        else if (serviceType === "BEMS") {
          finalWorkOrderJSON = {
            workOrderReport: {
              computerWorkOrderNo: getsubDetails?.workorderno || "",
              deptworkrequestno: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemdepartmentworkrequestheader?.deptworkrequestno || "",
              workOrderDate: getsubDetails?.workorderdate || "",
              assetNo: getsubDetails?.assetNo || "",
              description: getsubDetails?.assetDescription || "",
              location: getsubDetails?.locationdesc || "",
              workGroup: getsubDetails?.workGroup || "",
              workGroupdescription: getsubDetails?.wgdesc || "",
            },
            workOrderReceiptandClassification: {
              category: getsubDetails?.workordercategory || "",
              type: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemworkordertype?.workordertype || "",
              priority:
                getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemworkorderpriority?.workorderpriority || "",
            },
            assessment: {
              respondedBy: getsubDetails?.assessmentEmployeename || "",
              respondStartDateandTime: getsubDetails?.bemuscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.responsestartdate || "",
              respondFinding: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.respondfinding || "",
              respondType: getsubDetails?.bemworespondtype || " ",
              designation: getsubDetails?.assessmentDesignation || "",
              respondEndDateTime: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.responseenddate || "",
              taskCode: getsubDetails?.taskcode || "",
              vendorId: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwoassessmentheaders?.[0]?.vendorid || "",

            },
            repairDetails: {
              employeeDetails: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.employeeName || "") : [],
              flag: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.flagname || "") : [],
              pic: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.pic || "") : [],
              activity: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.activity || "") : [],
              strtDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.startDate || "") : [],
              endDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.endDate || "") : [],
              repairDuration: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.repairDuration || "") : [],
              remarks: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.remarks || "") : [],

            },
            repairDetailsForOutSource: {
              Vendor: vendorName || '',
              VendorTechnical: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.vendortechnician || "") : [],
              flag: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.flagname || "") : [],
              pic: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.pic || "") : [],
              activity: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.activity || "") : [],
              strtDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.startDate || "") : [],
              endDateTime: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.endDate || "") : [],
              repairDuration: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.repairDuration || "") : [],
              remarks: dropdownDetails?.length ? dropdownDetails.map(filter => filter?.remarks || "") : [],

            },
            partReplacement: {
              itemOrPartCode: partReplacementData?.map(part => part?.partCode) || " ",
              itemdescription: partReplacementData?.map(part => part?.itemdesc) || "",
              quantityUsed: partReplacementData?.map(part => part?.quantityUsed) || "",
            },
            unScheduleWorkCarriedOutBy: {
              employeeName: dropdownDetails?.map(filter => filter?.employeeName) || "",
              employeeId: dropdownDetails?.map(filter => filter?.employeeCode) || "",
              startDateTime: dropdownDetails?.map(filter => filter?.startDate) || "",
              endDateTime: dropdownDetails?.map(filter => filter?.endDate) || "",
              repairHours: dropdownDetails?.map(filter => filter?.repairDuration) || "",
            },
            sparePartsUsed: {
              partNo: taskDetails[0]?.taskcode || " ",
              PartDescription: taskDetails[0]?.taskdesc || " ",
              ItemNo: partReplacementData[0]?.itemdesc || " ",
              quantity: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwopartsreplacedetails?.[0]?.quantityused || "",
              cost: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwopartsreplacedetails?.[0]?.partscost || "",
            },
            costDetails: {
              breakDownCost: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.breakdowncostpurorderno || "",
              poNumber: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || "",
              ppmCost: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcost || "",
              ppmPONumber: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.ppmcostpurorderno || "",
              ppmCostByContract: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractppmcost || "",
              contractReferenceNumber: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.contractrefno || "",
              sparPartCost: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.sparepartscost || "",
              totalWoCost: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.totalwocost || "",
            },
            completionDetails: {
              rootCause: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.rootcause || "",
              startDateTime: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.startdate || "",
              AcceptedBy: getsubDetails?.completionEmployeename || getsubDetails?.completionByEmployeename || "",
              Designation: getsubDetails?.completionDesignation || getsubDetails?.completionByDesignation || "",
              ActionTaken: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.actiontaken || "",
              endDateTime: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.enddate || "",
              assetRequiredbutnotAvailable: getsubDetails?.bemscheduledworkorderheaders?.[0]?.bemscheduledwocompletiondetails?.[0]?.isassetreqnotavail || "",
            }
          };
        }
      }

    }
  } catch (error) {
    console.error("Error building finalWorkOrderJSON:", error);
  }



  // useEffect(() => {

  // }, [dropdownDetails]);
  const inhouseData = finalWorkOrderJSON?.assessment?.respondType === "Inhouse"
    ? [
      finalWorkOrderJSON?.repairDetails?.employeeDetails || '',
      finalWorkOrderJSON?.repairDetails?.flag || '',
      finalWorkOrderJSON?.repairDetails?.pic || '',
      finalWorkOrderJSON?.repairDetails?.activity || '',
      finalWorkOrderJSON?.repairDetails?.strtDateTime
        ? moment(finalWorkOrderJSON.repairDetails.strtDateTime).format('DD/MM/YYYY')
        : '',
      finalWorkOrderJSON?.repairDetails?.endDateTime
        ? moment(finalWorkOrderJSON.repairDetails.endDateTime).format('DD/MM/YYYY')
        : '',
      finalWorkOrderJSON?.repairDetails?.repairDuration || '',
      finalWorkOrderJSON?.repairDetails?.remarks || '',
    ]
    : [];


    const outsourceData =
    finalWorkOrderJSON?.assessment?.respondType === "Outsource"
      ? [
        finalWorkOrderJSON?.repairDetailsForOutSource?.Vendor || '',  
        finalWorkOrderJSON?.repairDetailsForOutSource?.VendorTechnical?.[0] || '', 
        finalWorkOrderJSON?.repairDetailsForOutSource?.flag?.[0] || '',
        finalWorkOrderJSON?.repairDetailsForOutSource?.pic?.[0] || '',
        finalWorkOrderJSON?.repairDetailsForOutSource?.activity?.[0] || '',
        finalWorkOrderJSON?.repairDetailsForOutSource?.strtDateTime?.[0]
          ? moment(finalWorkOrderJSON.repairDetailsForOutSource.strtDateTime[0]).format('DD/MM/YYYY HH:mm:ss')
          : '',
        finalWorkOrderJSON?.repairDetailsForOutSource?.endDateTime?.[0]
          ? moment(finalWorkOrderJSON.repairDetailsForOutSource.endDateTime[0]).format('DD/MM/YYYY HH:mm:ss')
          : '',
        finalWorkOrderJSON?.repairDetailsForOutSource?.repairDuration?.[0] || '',
        finalWorkOrderJSON?.repairDetailsForOutSource?.remarks?.[0] || ''
      ]
      : [];


      
    
            
  const sections = [
    {
      title: 'Work Order Report', data: [
        ["Work Order No.(Auto)", finalWorkOrderJSON?.workOrderReport?.computerWorkOrderNo],
        ["Reference/Work Request No", finalWorkOrderJSON?.workOrderReport?.deptworkrequestno],
        ["Hospital", facilityname],
        ["Work Order Date", finalWorkOrderJSON?.workOrderReport?.workOrderDate
          ? moment(finalWorkOrderJSON.workOrderReport.workOrderDate).format("DD/MM/YYYY")
          : ""
        ],
        ["Asset No", finalWorkOrderJSON?.workOrderReport?.assetNo],
        ["Description", finalWorkOrderJSON?.workOrderReport?.description],
        ["Location", finalWorkOrderJSON?.workOrderReport?.location],
        ["Work Group", finalWorkOrderJSON?.workOrderReport?.workGroup],
        ["Work Group Description", finalWorkOrderJSON?.workOrderReport?.workGroupdescription]
      ]
    },
    {
      title: 'Work Order Receipt and Classification', data: [
        ["Category", "Type", "Priority"],
        [finalWorkOrderJSON?.workOrderReceiptandClassification?.category, finalWorkOrderJSON?.workOrderReceiptandClassification?.type, finalWorkOrderJSON?.workOrderReceiptandClassification?.priority]
      ]
    },

    {
      title: 'Assessment', data: [
        ["Responded By", "Respond Start Date/Time", "Respond Finding", "Respond Type", "Designation", "Respond End Date/Time", "Task Code"],
        [finalWorkOrderJSON?.assessment?.respondedBy, finalWorkOrderJSON?.assessment?.respondStartDateandTime
          ? moment(finalWorkOrderJSON.assessment.respondStartDateandTime).format('DD/MM/YYYY HH:mm')
          : '', finalWorkOrderJSON?.assessment?.respondFinding, finalWorkOrderJSON?.assessment?.respondType, finalWorkOrderJSON?.assessment?.designation, finalWorkOrderJSON?.assessment?.respondEndDateTime
          ? moment(finalWorkOrderJSON.assessment.respondEndDateTime).format('DD/MM/YYYY')
          : '', finalWorkOrderJSON?.assessment?.taskCode
        ]
      ]
    },
    {
      title: 'Repair Details',
      data: [
        [
          "Employee Details", "Flag", "PIC", "Activity",
          "Start Date / Time", "End Date / Time", "Repair Duration", "Remarks"
        ],
        ...inhouseData.length ? [inhouseData] : []
      ]
    },
    {
      title: 'Repair Details(Outsource)',
      data: [
        [
          "Vendor Name", "Vendor Technician", "Flag", "PIC", "Activity",
          "Start Date / Time", "End Date / Time", "Repair Duration", "Remarks"
        ],
        ...outsourceData.length ? [outsourceData] : []
      ]
    },


    {
      title: 'Part Replacement', data: [
        ["Item/Part Code", "Item Description", "Quantity Used"],
        [finalWorkOrderJSON?.partReplacement?.itemOrPartCode, finalWorkOrderJSON?.partReplacement?.itemdescription, finalWorkOrderJSON?.partReplacement?.quantityUsed]
      ]
    },

    {
      title: 'Unscheduled Work Carried Out By', data: [
        ["Employee Name", "Employee ID", "Start Date / Time", "End Date / Time", "Repair Hours"],
        [finalWorkOrderJSON?.unScheduleWorkCarriedOutBy?.employeeName,
        finalWorkOrderJSON?.unScheduleWorkCarriedOutBy?.employeeId,
        finalWorkOrderJSON?.unScheduleWorkCarriedOutBy?.startDateTime
          ? moment(finalWorkOrderJSON.unScheduleWorkCarriedOutBy.startDateTime).format('DD/MM/YYYY')
          : '',
        finalWorkOrderJSON?.unScheduleWorkCarriedOutBy?.endDateTime
          ? moment(finalWorkOrderJSON.unScheduleWorkCarriedOutBy.endDateTime).format('DD/MM/YYYY')
          : '',
        finalWorkOrderJSON?.unScheduleWorkCarriedOutBy?.repairHours
        ]
      ]
    },

    {
      title: 'Spare Parts Used', data: [
        ["Part No", "Part Description", "Item No. (Item Description)", "Quantity", "Cost (RM)"],
        [finalWorkOrderJSON?.sparePartsUsed?.partNo,
        finalWorkOrderJSON?.sparePartsUsed?.PartDescription,
        finalWorkOrderJSON?.sparePartsUsed?.ItemNo,
        finalWorkOrderJSON?.sparePartsUsed?.quantity,
        finalWorkOrderJSON?.sparePartsUsed?.cost
        ]
      ]
    },


    {
      title: 'Cost Details', data: [

        ["Breakdown Cost", "PO Number", "PPM Cost", "PPM PO Number", "PPM Cost by Contract", "Contract Reference Number", "Spare Parts Cost", "Total WO Cost"],
        [finalWorkOrderJSON?.costDetails?.breakDownCost,
        finalWorkOrderJSON?.costDetails?.poNumber,
        finalWorkOrderJSON?.costDetails?.ppmCost,
        finalWorkOrderJSON?.costDetails?.ppmPONumber,
        finalWorkOrderJSON?.costDetails?.ppmCostByContract,
        finalWorkOrderJSON?.costDetails?.contractReferenceNumber,
        finalWorkOrderJSON?.costDetails?.sparPartCost,
        finalWorkOrderJSON?.costDetails?.totalWoCost
        ]
      ]
    },

    {
      title: 'Completion Details', data: [
        ["Start Date/Time", "Accepted By", "Designation", "Action Taken", "End Date/Time", "Asset Required but not Available"],
        [finalWorkOrderJSON?.completionDetails?.startDateTime
          ? moment(finalWorkOrderJSON.completionDetails.startDateTime).format('DD/MM/YYYY')
          : '',
        finalWorkOrderJSON?.completionDetails?.AcceptedBy,
        finalWorkOrderJSON?.completionDetails?.Designation,
        finalWorkOrderJSON?.completionDetails?.ActionTaken,
        finalWorkOrderJSON?.completionDetails?.endDateTime
          ? moment(finalWorkOrderJSON.completionDetails.endDateTime).format('DD/MM/YYYY')
          : '',
        finalWorkOrderJSON?.completionDetails
          ?.assetRequiredbutnotAvailable
          ? "Yes"
          : "No"
        ]
      ]
    }
  ];
  dispatch(setFinalWorkOrderJSON(sections));


  return (
    <>
      {loading ? ( // Display loading spinner while loading
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
          <CircularProgress />
        </Box>
      ) : (
        <div className="finalreport-table-container">
          <div id="printableArea">
            <table>
              <thead>
                <tr>
                  <th
                    colSpan={2}
                    className="unscheduled-center-text"
                    style={{
                      backgroundColor: '#009999',
                      color: 'white',
                      textAlign: 'center',
                    }}
                  >
                    Work Order Report
                  </th>

                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="label"> Work Order No.(Auto)</td>
                  <td>
                    {finalWorkOrderJSON?.workOrderReport?.computerWorkOrderNo}
                  </td>
                </tr>
                <tr>
                  <td className="label"> Reference/Work Request No</td>
                  <td>
                    {finalWorkOrderJSON?.workOrderReport?.deptworkrequestno}
                  </td>
                </tr>
                <tr>
                  <td className="label">Hospital</td>
                  <td>{facilityname}</td>
                </tr>
                <tr>
                  <td className="label">Work Order Date</td>
                  <td>{finalWorkOrderJSON?.workOrderReport?.workOrderDate ?
                    moment(finalWorkOrderJSON.workOrderReport.workOrderDate).format('DD/MM/YYYY') : ''}</td>
                </tr>
                <tr>
                  <td className="label">Asset No</td>
                  <td>{finalWorkOrderJSON?.workOrderReport?.assetNo}</td>
                </tr>
                <tr>
                  <td className="label">Description</td>
                  <td>{finalWorkOrderJSON?.workOrderReport?.description}</td>
                </tr>
                <tr>
                  <td className="label">Location</td>
                  <td>{finalWorkOrderJSON?.workOrderReport?.location}</td>
                </tr>
                <tr>
                  <td className="label">Work Group</td>
                  <td>{finalWorkOrderJSON?.workOrderReport?.workGroup}</td>
                </tr>
                <tr>
                  <td className="label">Work Group Description</td>
                  <td>
                    {finalWorkOrderJSON?.workOrderReport?.workGroupdescription}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="unscheduled-work">
              <table>
                <thead>
                  <tr>
                    <th colSpan={5} className="unscheduled-center-text" style={{
                      backgroundColor: '#009999',
                      color: 'white',
                      textAlign: 'center',
                    }}>
                      Work Order Receipt and Classification
                    </th>
                  </tr>
                  <tr>
                    <th>Category</th>
                    <th>Type</th>
                    <th>Priority</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {
                        finalWorkOrderJSON?.workOrderReceiptandClassification
                          ?.category
                      }
                    </td>
                    <td>
                      {finalWorkOrderJSON?.workOrderReceiptandClassification?.type}
                    </td>
                    <td>
                      {
                        finalWorkOrderJSON?.workOrderReceiptandClassification
                          ?.priority
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="unscheduled-work">
              <table>
                <thead>
                  <tr>
                    <th colSpan={8} className="unscheduled-center-text" style={{
                      backgroundColor: '#009999',
                      color: 'white',
                      textAlign: 'center',
                    }}>
                      Assessment
                    </th>
                  </tr>
                  <tr>
                    <th>Responded By</th>
                    <th>Respond Start Date/Time</th>
                    <th>Respond Finding</th>
                    <th>Respond Type</th>
                    <th>Designation(Responder)</th>
                    <th>Respond End Date/Time</th>
                    <th>Task Code</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{finalWorkOrderJSON?.assessment?.respondedBy}</td>
                    <td>
                      {finalWorkOrderJSON?.assessment?.respondStartDateandTime ?
                        moment(finalWorkOrderJSON.assessment.respondStartDateandTime).format('DD/MM/YYYY HH:mm:ss') : ''}
                    </td>
                    <td>{finalWorkOrderJSON?.assessment?.respondFinding}</td>
                    <td>{finalWorkOrderJSON?.assessment?.respondType}</td>
                    <td>{finalWorkOrderJSON?.assessment?.designation}</td>
                    <td>{finalWorkOrderJSON?.assessment?.respondEndDateTime ?
                      moment(finalWorkOrderJSON.assessment.respondEndDateTime).format('DD/MM/YYYY HH:mm:ss') : ''}</td>
                    <td>{finalWorkOrderJSON?.assessment?.taskCode}</td>
                  </tr>

                </tbody>
              </table>
            </div>
            <div className="unscheduled-work">
              <table>
                <thead>
                  <tr>
                    <th colSpan={10} className="unscheduled-center-text" style={{
                      backgroundColor: '#009999',
                      color: 'white',
                      textAlign: 'center',
                    }}>
                      Repair Details(Inhouse)
                    </th>
                  </tr>
                  <tr>
                    <th>Employee Details</th>
                    <th>Flag</th>
                    <th>PIC</th>
                    <th>Activity</th>
                    <th>Start Date / Time</th>
                    <th>End Date / Time</th>
                    <th>Repair Duration</th>
                    <th>Remarks</th>

                  </tr>
                </thead>
                <tbody>
                  {finalWorkOrderJSON?.assessment?.respondType?.toLowerCase() === "inhouse" &&
                    Array.isArray(dropdownDetails) &&
                    dropdownDetails.length > 0 ? (
                    dropdownDetails.map((filter, index) => (
                      <tr key={index}>
                        <td>{filter?.employeeName || ""}</td>
                        <td>{filter?.flagname || ""}</td>
                        <td>{filter?.pic || ""}</td>
                        <td>{filter?.activity || ""}</td>
                        <td>
                          {filter?.startDate
                            ? moment(filter.startDate).format("DD/MM/YYYY HH:mm:ss")
                            : ""}
                        </td>
                        <td>
                          {filter?.endDate
                            ? moment(filter.endDate).format("DD/MM/YYYY HH:mm:ss")
                            : ""}
                        </td>
                        <td>{filter?.repairDuration || ""}</td>
                        <td>{filter?.remarks || ""}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} style={{ textAlign: "center" }}></td>
                    </tr>
                  )}
                </tbody>



              </table>
            </div>
            <div className="unscheduled-work">
              <table>
                <thead>
                  <tr>
                    <th colSpan={11} className="unscheduled-center-text" style={{
                      backgroundColor: '#009999',
                      color: 'white',
                      textAlign: 'center',
                    }}>
                      Repair Details(Outsource)
                    </th>
                  </tr>
                  <tr>
                    <th>Vendor</th>
                    <th>Vendor Technician</th>
                    <th>Flag</th>
                    <th>PIC</th>
                    <th>Activity</th>
                    <th>Start Date / Time</th>
                    <th>End Date / Time</th>
                    <th>Repair Duration</th>
                    <th>Remarks</th>

                  </tr>
                </thead>
                <tbody>
                  {finalWorkOrderJSON?.assessment?.respondType === "Outsource" &&
                    dropdownDetails?.length > 0 ? (
                    dropdownDetails.map((filter, index) => {
                      
                      return (
                        <tr key={index}>
                          <td>{vendorName || ""}</td>
                          <td>{filter?.vendortechnician || ""}</td>
                          
                          <td>{filter?.flagname || ""}</td>
                          <td>{filter?.pic || ""}</td>
                          <td>{filter?.activity || ""}</td>
                          <td>
                            {filter?.startDate
                              ? moment(filter.startDate).format("DD/MM/YYYY HH:mm:ss")
                              : ""}
                          </td>
                          <td>
                            {filter?.endDate
                              ? moment(filter.endDate).format("DD/MM/YYYY HH:mm:ss")
                              : ""}
                          </td>
                          <td>{filter?.repairDuration || ""}</td>
                          <td>{filter?.remarks || ""}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="9" style={{ textAlign: "center" }}></td>
                    </tr>
                  )}
                </tbody>





              </table>
            </div>
            <div className="unscheduled-work">
              <table>
                <thead>
                  <tr>
                    <th colSpan={3} className="unscheduled-center-text" style={{
                      backgroundColor: '#009999',
                      color: 'white',
                      textAlign: 'center',
                    }}>
                      Part Replacement
                    </th>
                  </tr>
                  <tr>
                    <th>Item/Part Code</th>
                    <th>Item Description</th>
                    <th>Quantity Used</th>
                  </tr>
                </thead>
                <tbody>
                  {partReplacementData.map((part, index) => (
                    <tr key={index}>
                      <td>{part?.partCode}</td>
                      <td>{part?.itemdesc}</td>
                      <td>{part?.quantityUsed}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="unscheduled-work">
              <table>
                <thead>
                  <tr>
                    <th colSpan={5} className="unscheduled-center-text" style={{
                      backgroundColor: '#009999',
                      color: 'white',
                      textAlign: 'center',
                    }}>
                      Unscheduled Work Carried Out By
                    </th>
                  </tr>
                  <tr>
                    <th>Employee Name</th>
                    <th>Employee ID</th>
                    <th>Start Date / Time</th>
                    <th>End Date / Time</th>
                    <th>Repair Hours</th>
                  </tr>
                </thead>
                <tbody>
                  {dropdownDetails.map((filter, index) => (
                    <tr key={index}>
                      <td>{filter?.employeeName}</td>
                      <td>{filter?.employeeCode}</td>
                      <td>{filter?.startDate ?
                        moment(filter.startDate).format('DD/MM/YYYY HH:mm:ss') : ''}</td>
                      <td>{filter?.endDate ?
                        moment(filter.endDate).format('DD/MM/YYYY HH:mm:ss') : ''}</td>
                      <td>{filter?.repairDuration}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="unscheduled-work">
              <table>
                <thead>
                  <tr>
                    <th colSpan={5} className="unscheduled-center-text" style={{
                      backgroundColor: '#009999',
                      color: 'white',
                      textAlign: 'center',
                    }}>
                      Spare Parts Used
                    </th>
                  </tr>
                  <tr>
                    <th>Part No.</th>
                    <th>Part Description</th>
                    <th>Item No. (Item Description)</th>
                    <th>Quantity</th>
                    <th>Cost (RM)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{finalWorkOrderJSON?.sparePartsUsed?.partNo}</td>
                    <td>{finalWorkOrderJSON?.sparePartsUsed?.PartDescription}</td>
                    <td>{finalWorkOrderJSON?.sparePartsUsed?.ItemNo}</td>
                    <td>{finalWorkOrderJSON?.sparePartsUsed?.quantity}</td>
                    <td>{finalWorkOrderJSON?.sparePartsUsed?.cost}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="unscheduled-work">
              <table>
                <thead>
                  <tr>
                    <th colSpan={8} className="unscheduled-center-text" style={{
                      backgroundColor: '#009999',
                      color: 'white',
                      textAlign: 'center',
                    }}>
                      Cost Details
                    </th>
                  </tr>
                  <tr>
                    <th>Breakdown Cost (by Purchase Order)</th>
                    <th>PO Number</th>
                    <th>PPM Cost (by Purchase Order)</th>
                    <th>PO Number</th>
                    <th>PPM Cost (by Contract)</th>
                    <th>Contract Reference Number</th>
                    <th>Spare Part Cost (Link with Inventory Submodule)</th>
                    <th>Total WO Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{finalWorkOrderJSON?.costDetails?.breakDownCost}</td>
                    <td>{finalWorkOrderJSON?.costDetails?.poNumber}</td>
                    <td>{finalWorkOrderJSON?.costDetails?.ppmCost}</td>
                    <td>{finalWorkOrderJSON?.costDetails?.ppmPONumber}</td>
                    <td>{finalWorkOrderJSON?.costDetails?.ppmCostByContract}</td>
                    <td>
                      {finalWorkOrderJSON?.costDetails?.contractReferenceNumber}
                    </td>
                    <td>{finalWorkOrderJSON?.costDetails?.sparPartCost}</td>
                    <td>{finalWorkOrderJSON?.costDetails?.totalWoCost}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="unscheduled-work">
              <table>
                <thead>
                  <tr>
                    <th colSpan={8} className="unscheduled-center-text" style={{
                      backgroundColor: '#009999',
                      color: 'white',
                      textAlign: 'center',
                    }}>
                      Completion Details
                    </th>
                  </tr>
                  <tr>

                    <th>Start Date / Time</th>
                    <th>Accepted By</th>
                    <th>Designation</th>
                    <th>Action Taken</th>
                    <th>End Date / Time</th>
                    <th>Asset Required but not available</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>

                    <td>
                      {
                        finalWorkOrderJSON?.completionDetails?.startDateTime ?
                          moment(finalWorkOrderJSON.completionDetails.startDateTime).format('DD/MM/YYYY HH:mm:ss') : ''

                      }
                    </td>
                    <td>{finalWorkOrderJSON?.completionDetails?.AcceptedBy}</td>
                    <td>{finalWorkOrderJSON?.completionDetails?.Designation}</td>
                    <td>{finalWorkOrderJSON?.completionDetails?.ActionTaken}</td>
                    <td>
                      {
                        finalWorkOrderJSON?.completionDetails?.endDateTime ?
                          moment(finalWorkOrderJSON.completionDetails.endDateTime).format('DD/MM/YYYY HH:mm:ss') : ''
                      }
                    </td>
                    <td>
                      {finalWorkOrderJSON?.completionDetails
                        ?.assetRequiredbutnotAvailable
                        ? "Yes"
                        : "No"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
})
export default WorkorderFinalreport;
